<template>
  <div class="page page--editor">
    <nav-bar />
    <div class="page-wrapper">
      <div class="certs">
        <div class="certs__main">
          <div class="page-nav">
            <h2 class="page-nav__title">Шаг 3</h2>
            <a class="page-nav__link" @click="checkAndBack">Компоненты </a>
            <p class="page-nav__current">/ Мои сертификаты</p>
          </div>
          <p v-if="isWizard" class="wizard-step">Шаг 3</p>
          <h1 class="editor--title">Мои сертификаты</h1>
          <div class="certs__items">
            <div
              class="certs__item"
              v-for="(cert, index) in this.certs"
              :key="index"
            >
              <img
                :src="
                  cert.preview && Object.keys(cert.preview).length > 0
                    ? host + cert.preview.file
                    : host + cert.file
                "
                alt=""
              />
              <div class="certs__panel">
                <button class="certs__delete" @click="deleteItem(index)">
                  <svg-icon type="delete" />
                </button>
              </div>
            </div>
            <label class="certs__upload">
              <svg-icon type="file" />
              <input
                type="file"
                accept="application/pdf,application/vnd.cups-pdf,application/vnd.sealedmedia.softseal.pdf,image/png,image/jpeg"
                @change="e => autoUpload(e.target.files)"
              />
            </label>
          </div>
        </div>
        <div class="certs__buttons">
          <button class="pBtn pBtn--noborder" @click="checkAndBack">
            <svg-icon type="back" />
            Назад
          </button>
          <!--<button class="pBtn pBtn&#45;&#45;blue">Сохранить</button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Certificates",
  props: ["isWizard"],
  computed: {
    ...mapGetters(["getComponentByName"]),
    host() {
      return process.env.VUE_APP_API_ROOT;
    }
  },
  data() {
    return {
      certs: []
    };
  },
  methods: {
    checkAndBack() {
      if (!this.certs.length) {
        this.$store.dispatch("syncComponent", {
          id: this.getComponentByName("Certificates").id,
          content: Object.assign({}, { items: this.certs }),
          enabled: false
        });
      }
      this.$router.go(-1);
      this.GAEvent("step_3-upload-certificate_back");
    },
    autoUpload(files) {
      const file = files[0];
      let extension = file.name
        .split(".")
        .pop()
        .toLowerCase();
      if (!["pdf", "png", "jpg"].includes(extension)) {
        this.$eventBus.$emit("showError", { error: "Неверный тип файла" });
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      this.axios({
        method: "post",
        url: "upload",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      })
        .then(response => {
          this.loading = false;
          return this.certs.push({
            name: file.name,
            type: file.name.split(".").pop(),
            ...response.data.result
          });
        })
        .then(() => {
          this.saveToVuexAndServer();
          this.GAEvent(
            "step_3-upload-certificate",
            "uploaded-certificate",
            this.certs.length
          );
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    deleteItem(index) {
      this.certs.splice(index, 1);
      this.saveToVuexAndServer();
    },
    saveToVuexAndServer() {
      const enabled = this.certs.length > 0;
      return this.$store.dispatch("syncComponent", {
        id: this.getComponentByName("Certificates").id,
        content: {
          items: this.certs
        },
        enabled
      });
    }
  },
  mounted() {
    if (this.getComponentByName("Certificates")) {
      const statecontent = Object.assign(
        {},
        this.getComponentByName("Certificates").content
      );
      if (statecontent.items) {
        this.certs = statecontent.items;
      } else {
        this.certs = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vars";

.page {
  background: #3479cc;
  @media #{$tablet} {
    padding-bottom: 0;
  }

  &-wrapper {
    max-width: 100%;
    display: flex;
    justify-content: center;
    @media #{$tablet} {
      margin: 0;
      padding: 0;
    }
  }
}

.certs {
  width: 100%;
  max-width: 1200px;
  background: #f4f4f4;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  @media #{$tablet} {
    min-height: calc(100vh - 75px);
    border-radius: 0;
    justify-content: space-between;
  }
  @media #{$mobile} {
    background: #ffffff;
  }

  &__main {
    padding: 60px 70px;
    @media #{$tablet} {
      padding: 30px;
    }
    @media #{$mobile} {
      padding: 30px 15px;
    }
  }

  &__buttons {
    background: #ffffff;
    padding: 30px 70px;
    display: flex;
    justify-content: space-between;
    @media #{$mobile} {
      flex-direction: column-reverse;
      padding: 0 15px;
    }
  }

  &__items {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  &__item {
    flex-basis: calc(100% / 3 - 30px);
    margin-right: 30px;
    height: 200px;
    display: flex;
    overflow: hidden;
    border-radius: 12px;
    justify-content: center;
    position: relative;
    margin-bottom: 30px;
    @media #{$tablet} {
      flex-basis: calc(50% - 30px);
    }
    @media #{$mobile} {
      flex-basis: 100%;
      margin: 0 0 15px;
    }

    &:hover {
      .certs__panel {
        opacity: 1;
        pointer-events: auto;
      }
    }

    &:nth-child(3n) {
      margin-right: 0;
    }

    img {
      height: auto;
      max-height: 100%;
    }
  }

  &__panel {
    position: absolute;
    left: 0;
    right: 0;
    top: 80%;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    opacity: 0;
    pointer-events: none;
    transition: 200ms ease;
  }

  &__delete {
    width: 25%;
    background: #ffffff;
    border: none;
    outline: none;
    cursor: pointer;
  }

  &__upload {
    height: 200px;
    flex-basis: calc(100% / 3 - 30px);
    border-radius: 12px;
    background: #cccccc;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    @media #{$tablet} {
      flex-basis: calc(50% - 30px);
    }
    @media #{$mobile} {
      flex-basis: 100%;
      background: #f2f2f2;
      margin: 0 0 15px;
    }

    input {
      display: none;
    }
  }
}
</style>
